// Empty = same-origin. In dev (CRA on :3000) the proxy in client/package.json
// forwards non-public requests to the API on :3001; in prod everything is
// served from the same Cloud Run origin, so a relative URL is correct.
// Override via REACT_APP_SERVER_ORIGIN if you need to point at a different host.
const SERVER_ORIGIN = process.env.REACT_APP_SERVER_ORIGIN ?? '';

function getToken() {
  return localStorage.getItem('iamhero_token');
}

export function setToken(token) {
  if (token) localStorage.setItem('iamhero_token', token);
  else localStorage.removeItem('iamhero_token');
}

// Auth header for direct fetch() calls that bypass the `api` helper — e.g. PDF
// blob downloads. Returns {} when logged out so the call still works for the
// public (paid-order) path; an admin's token unlocks the admin-only bypass.
export function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(path, opts = {}) {
  const token = getToken();
  const headers = { ...(opts.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!(opts.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(path, { ...opts, headers });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (data?.error) msg = data.error;
    } catch {}
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  put: (path, body) => request(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path, body) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: 'DELETE' }),
  postForm: (path, formData) => request(path, { method: 'POST', body: formData }),
};

export function resolveAsset(url) {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  return `${SERVER_ORIGIN}${url}`;
}
